import React, { useState } from 'react';
import store from '../../../store';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { RoleType } from '../../../constants/enum/role-type.enum';
import { Text, SideBarWrapper, SideBarBody, NavLinks, SideBarFooter, NavBtn, SubMenu, SubMenuBody } from './styles';
import { House, Gear, Postcard, PersonCheckFill, PersonCircle, Calendar2Check, People, CaretRightFill, CaretDownFill, Person, Dice5, TicketDetailed } from 'react-bootstrap-icons';

interface Menu {
  to: string,
  title: string,
  icon: React.ReactNode,
  pathname: string,
  sub?: Array<Sub>
}

interface Sub {
  to: string,
  title: string,
  icon: React.ReactNode,
  pathname: string,
}

const Sidebar: React.FC = () => {

  const location = useLocation();
  const authInfo = store.getState().auth.authInfo;

  const sideBarMenus: Array<Menu> = [
    // {
    //   to: '/home',
    //   title: 'Overview',
    //   icon: <House className="ms-3 me-3" height={"20"} width={"20"} />,
    //   pathname: '/home',
    //   sub: undefined,
    // },
    {
      to: '/users',
      title: 'Usuários',
      icon: <PersonCheckFill className="ms-3 me-3" height={"20"} width={"20"} />,
      pathname: '/reported-users',
      sub: undefined,
    },
    {
      to: '/communities',
      title: 'Comunidades',
      icon: <People className="ms-3 me-3" height={"20"} width={"20"} />,
      pathname: '/reported-communities',
      sub: undefined,
    },
    {
      to: '/posts',
      title: 'Publicações',
      icon: <Postcard className="ms-3 me-3" height={"20"} width={"20"} />,
      pathname: '/reported-posts',
      sub: undefined,
    },
    {
      to: '',
      title: 'Eventos',
      icon: <Calendar2Check className="ms-3 me-3" height={"20"} width={"20"} />,
      pathname: '',
      sub: [
        {
          to: '/events',
          title: 'Arena Sportle',
          icon: <Dice5 className="ms-3 me-3" height={"20"} width={"20"} />,
          pathname: '/events',
        },
        {
          to: '/user-events',
          title: 'Usuário',
          icon: <Person className="ms-3 me-3" height={"20"} width={"20"} />,
          pathname: '/reported-events',
        },
      ]
    },
    {
      to: '/coupons',
      title: 'Cupons',
      icon: <TicketDetailed className="ms-3 me-3" height={"20"} width={"20"} />,
      pathname: '/discount-coupons',
      sub: undefined,
    },
  ];

  return (
    <SideBarWrapper>
      <SideBarBody>
        {sideBarMenus.map((m, i) => (
          <SideBarMenu
            to={m.to}
            icon={m.icon}
            title={m.title}
            pathname={m.pathname}
            sub={m.sub}
          />
        ))}
      </SideBarBody>
      {/* Basic Menu */}
      {(authInfo?.role !== RoleType.BASIC)
        && <SideBarFooter>
          <li>
            <NavLinks
              to={{ pathname: '/accounts' }}
              className={classNames('', { active: location.pathname === '/accounts' })}
            >
              <div>
                <PersonCircle className="ms-3 me-3" height={"20"} width={"20"} />
                <Text>Contas</Text>
              </div>
            </NavLinks>
          </li>
          {/* <li>
            <NavLinks
              to={{ pathname: '/settings' }}
              className={classNames('', { active: location.pathname === '/settings' })}
            >
              <div>
                <Gear className="ms-3 me-3" height={"20"} width={"20"} />
                <Text>Configurações</Text>
              </div>
            </NavLinks>
          </li> */}
        </SideBarFooter>
      }
    </SideBarWrapper>
  );
};

const SideBarMenu = (m: Menu) => {

  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <li>
      {(m.sub?.length) ? (
        <NavBtn onClick={() => { setExpanded(!expanded) }}>
          <div>
            {m.icon}
            <Text>{m.title}</Text>
          </div>
          <div style={{ overflow: 'hidden' }}>
            {(expanded)
              ? <CaretDownFill className="ms-3 me-3" height={"10"} width={"10"} />
              : <CaretRightFill className="ms-3 me-3" height={"10"} width={"10"} />
            }
          </div>
        </NavBtn>
      ) : (
        <NavLinks to={{ pathname: m.to }} className={classNames('', { active: location.pathname === `${m.pathname}` })}>
          <div>
            {m.icon}
            <Text>{m.title}</Text>
          </div>
        </NavLinks>
      )}
      {/* Sub Menu */}
      {(m.sub && expanded) &&
        <SubMenuBody>
          {(m.sub.map((sub, i) => (
            <li>
              <SubMenu
                key={i}
                to={{ pathname: sub.to }}
                className={classNames('', { active: location.pathname === `${sub.pathname}` })}
              >
                <div>
                  {sub.icon}
                  <Text>{sub.title}</Text>
                </div>
              </SubMenu>
            </li>
          )))}
        </SubMenuBody>
      }
    </li>
  );
}

export default Sidebar;
